/** Édition médecin : autorisée tant que la pharmacie n’a pas délivré. */

export function isPharmacyDispensed(status) {
  return String(status || '').toUpperCase() === 'DISPENSED';
}

export function canEditPrescription(prescription, pharmacyTransfer = null) {
  if (!prescription) return false;
  const st = String(prescription.status || '').toUpperCase();
  if (st === 'CANCELLED' || st === 'FULFILLED') return false;
  const pharmacyStatus = pharmacyTransfer?.status ?? prescription.pharmacy_status;
  if (isPharmacyDispensed(pharmacyStatus)) return false;
  return st === 'ACTIVE';
}

export function pharmacyStatusLabel(status) {
  switch (String(status || '').toUpperCase()) {
    case 'PENDING':
      return 'En attente pharmacie';
    case 'VALIDATED':
      return 'Validée pharmacie';
    case 'DISPENSED':
      return 'Délivrée';
    case 'CANCELLED':
      return 'Annulée pharmacie';
    default:
      return null;
  }
}

export function prescriptionToConsultationStub(prescription) {
  if (!prescription) return null;
  return {
    id: prescription.consultation_id || null,
    patient_name: prescription.patient_name,
    patient_phone: prescription.patient_phone,
    site_id: prescription.site_id,
    site_name: prescription.site_name,
    doctor_name: prescription.doctor_name,
    consultation_date: prescription.linked_consultation_date || prescription.prescribed_date
  };
}
